export enum UserRole {
  EXTERNAL_MULTIACCESS = 'external-multiaccess',
  INTERNAL_MULTIACCESS = 'internal-multiaccess',
  MAIN = 'main',
}
